module.exports = __webpack_public_path__ + "img/gift.4aeb5fb7.png";